.c2{position:absolute;}